export function formatProductSize(item) {
    if (!item.thcMgPerUnit || item.thcMgPerUnit.trim().length === 0)
        return "";
    const cat = item.productCategory.trim().toLowerCase();
    if (cat === "edibles" || cat === "edible") {
        return `${item.thcMgPerUnit}mg THC`;
    }
    return "";
}
//# sourceMappingURL=format-product-size.js.map